import { extendTheme } from "@chakra-ui/react";

// Or export `extendBaseTheme` if you only want the default Chakra theme tokens to extend (no default component themes)
export const customTheme = extendTheme({
    fonts: {
        heading: `'Raleway', sans-serif`,
        body: `'Quicksand', sans-serif`,
      },
    colors: {
        brand: {
          900: "#1a365d",
          800: "#153e75",
          700: "#2a69ac",
        },
        violet: {
          50: "#f0f0f5", // Lightest shade
          100: "#d2d2e0",
          200: "#b4b4cb",
          300: "#9696b6",
          400: "#7878a1", 
          500: "#5e5e87", 
          700: "#494969", 
          800: "#34344b", 
          900: "#20202E", // Default shade 
          1000: "#0a0a0f", // Darkest shade
        },
        rose: "#D40551",
        beige: "#8B7458",
        green:"#1D3943",
        brownW:"#2F201D",
        dark:"#323232",
      },
})


